export const chart33Options = {
    colors: ['#3936C0'],
    chart: {
        toolbar: {
            show: false
        },
        sparkline: {
            enabled: true
        }
    },
    dataLabels: {
        enabled: false
    },
    stroke: {
        color: '#3936C0',
        curve: 'smooth',
        width: 2
    },
    fill: {
        color: '#3936C0',
        gradient: {
            shade: 'light',
            type: 'vertical',
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.6,
            opacityTo: 0,
            stops: [0, 100]
        }
    },
    legend: {
        show: false
    },
    xaxis: {
        categories: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        crosshairs: {
            width: 0
        }
    },
    yaxis: {
        min: 0
    }
};

export const chart33Data = [
    {
        name: 'Transactions',
        data: [47, 45, 54, 38, 56, 24, 65]
    }
];